import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class UnignoreDiscussionModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
  }
  className() {
    return 'UnignoreDiscussionModal Modal--small';
  }
  title() {
    return app.translator.trans('bizkaitarra-ignore-users.forum.unignore_discussion_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "Form-group"
    }, app.translator.trans('bizkaitarra-ignore-users.forum.unignore_discussion_modal.confirmation_text', {
      title: m("strong", null, this.discussion.title())
    })), m("div", {
      className: "Form-group",
      style: "display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px;"
    }, m(Button, {
      className: "Button",
      type: "button",
      onclick: () => this.hide()
    }, app.translator.trans('bizkaitarra-ignore-users.forum.unignore_discussion_modal.cancel_button')), m(Button, {
      className: "Button Button--warning",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('bizkaitarra-ignore-users.forum.unignore_discussion_modal.submit_button'))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.discussion.save({
      ignored: false
    }).then(() => {
      this.hide();
      if (this.attrs.onunignored) {
        this.attrs.onunignored();
      } else {
        m.redraw();
      }
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-ignore-users.forum.unignore_discussion_modal.success_message'));
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('bizkaitarra-ignore-users', 'forum/components/UnignoreDiscussionModal', UnignoreDiscussionModal);